<template>
    <div class="h100 flex-column">
        <div class="flex mt5 fs14 bold">
            <div>{{project.name}}</div>
            <div class="ml5">库存表</div>
        </div>
        <div class="flex-height mt10">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column prop="id" label="ID" width="180"></el-table-column>
                
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            project: {},
            tableData: []
        }
    },
    created() {
        this.project_id = this.$route.params.project_id;
        this.getProject();
        this.getInvProjects();
    },
    methods: {
        async getProject() {
            let rs = await this.$api.project(this.project_id);
            if (rs.err == 0) {
                this.project = rs.data;
            }
        },
        async getInvProjects() {
            let rs = await this.$api.getInvProjects(this.project_id);
            if (rs.err == 0) {
                this.tableData = rs.data;
            }
        }
    }
}
</script>

<style lang="less" scoped>

</style>